import { Toaster } from "@/components/ui/toaster"
import { Toaster as Sonner } from "@/components/ui/sonner"
import { TooltipProvider } from "@/components/ui/tooltip"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Routes, Route, Navigate } from "react-router-dom"
import Footer from "../components/Footer"
import UserDashboard from "@/user/pages/UserDashboard"
import BookingPage from "@/user/pages/BookingPage"
import BookingHistory from "@/user/pages/BookingHistory"
import NotFound from "@/user/pages/NotFound"
import Confirmation from "@/user/pages/Confirmation"
import UserLogin from "@/user/pages/UserLogin"

const queryClient = new QueryClient()

const UserApp = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <div className="flex flex-col min-h-screen">
          <div className="flex-grow">
            <Routes>
              <Route path="/" element={<Navigate to="/user-login" replace />} />
              <Route path="/user-login" element={<UserLogin />} />
              <Route path="/user-dashboard" element={<UserDashboard />} />
              <Route path="/booking" element={<BookingPage />} />
              <Route path="/confirmation" element={<Confirmation />} />
              <Route path="/booking-history" element={<BookingHistory />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </TooltipProvider>
    </QueryClientProvider>
  )
}

export default UserApp